import { Modal, Radio } from "antd";
import { useState } from "react";
import SignagePlayer from "../SignagePlayer";

const PreviewMedia = ({ isModalOpen, media, closeModal }) => {
  const [orientation, setOrientation] = useState("horizontal");

  const handleOrientationChange = (e) => {
    setOrientation(e.target.value);
  };

  const modalWidth = orientation === "horizontal" ? 450 : 275; // adjust as needed
  const playerHeight = 400;

  return (
    <Modal
      title={`Preview Media - ${media.title}`}
      open={isModalOpen}
      onCancel={closeModal}
      footer={null}
      maskClosable={false}
      width={modalWidth}
    >
      <div className="mb-3">
        <label className="form-label me-3">Orientation</label>
        <Radio.Group
          onChange={handleOrientationChange}
          value={orientation}
          optionType="button"
          buttonStyle="solid"
        >
          <Radio value="horizontal">Horizontal</Radio>
          <Radio value="vertical">Vertical</Radio>
        </Radio.Group>
      </div>

      <div
        className={`preview-media-container ${orientation}`}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: playerHeight,
          overflow: "hidden",
        }}
      >
        <SignagePlayer
          playlist={[
            {
              media: { ...media, file_data: JSON.parse(media.file_data) },
              duration: 10000,
            },
          ]}
          classNames={`preview-media ${orientation}`}
          enableControls={true}
        />
      </div>
    </Modal>
  );
};

export default PreviewMedia;
